"use client"

import { memo, useState } from "react"
import { useRouter } from "next/navigation"
import { SearchIcon } from "@/components/ui/Icons"
import { NEWS_SEARCH_MAX_LENGTH, normalizeNewsSearchQuery } from "@/lib/newsSearch"

const HeaderSearch = ({ variant = "desktop", autoFocus = false, onSubmitSuccess }) => {
	const [query, setQuery] = useState("")
	const router = useRouter()
	const isMobile = variant === "mobile"

	const handleSubmit = (event) => {
		event.preventDefault()
		const trimmed = normalizeNewsSearchQuery(query)
		if (!trimmed) return
		router.push(`/search?q=${encodeURIComponent(trimmed)}`)
		onSubmitSuccess?.()
	}

	return (
		<form
			className={isMobile ? "header-search header-search--mobile" : "header-search"}
			onSubmit={handleSubmit}
			role="search"
		>
			<SearchIcon size={16} />
			<input
				type="search"
				value={query}
				onChange={(event) => setQuery(event.target.value.slice(0, NEWS_SEARCH_MAX_LENGTH))}
				maxLength={NEWS_SEARCH_MAX_LENGTH}
				className="header-search__input"
				placeholder="बातम्या, विषय, शहर शोधा..."
				aria-label="बातम्या शोधा"
				autoFocus={autoFocus}
			/>
		</form>
	)
}

export default memo(HeaderSearch)
